import React, { useContext, useEffect } from 'react'

import { ThemeProvider } from 'styled-components'
import { useDarkMode } from '../components/useDarkMode'
import { GlobalStyles } from '../components/Globalstyle'
import { lightTheme } from '../components/Themes'
import './App.css'
import Body from '../components/Body'
import Logo from '../components/Logo'
import Header from '../components/header/Header'
import HeaderBody from '../components/header/HeaderBody'
import Wallet from '../components/Wallet'
import Bridge from '../components/Bridge'
import NetworkBanner from '../components/NetworkBanner'

import { Swap } from '../components/swap/Swap'

import { supportedChains, swaapAppURI } from '../config'

import { Web3Context } from '../hooks/web3'

import { DarkModeSwitch } from 'react-toggle-dark-mode'

import { swaapPurple0, swaapPurple1 } from '../components/Themes'
import { PoolsPage } from '../components/pools/PoolsPage'
import { useTransactions } from '../components/transactions/TransactionContext'
import { HeaderTabs } from '../components/header/HeaderTabs'
import {
  HideBiggerThan,
  HideSmallerThan,
} from '../components/catalog/responsive/Hide'
import { StickyFooter } from '../components/header/StickyFooter'
import { useParams } from 'react-router-dom'
import { DepositPage } from '../components/pools/deposit/DepositPage'
import { WithdrawPage } from '../components/pools/deposit/WithdrawPage'
import Popups from '../components/confirmations/Popups/popups'
import AppStatus from '../components/AppStatus'
import { createVariousEvent, visitPage } from 'user-events-segment'
import { InjectedWindow } from '../utils/types'
import { WhitelistOfferPopup } from '../components/waitlist/popups/WhitelistOfferPopup'
import { useAccountState } from '../hooks/useAccountState'

import { claim } from '../api/waitlist/airtable'
import { WaitlistOfferPopup } from '../components/waitlist/popups/WaitlistOfferPopup'
import { SubscribePopup } from '../components/waitlist/popups/subscribe/SubscribePopup'
import { WaitlistCongratsXpBonusPopup } from '../components/waitlist/popups/WaitlistCongratsXpBonus'
import { desktopSize } from '../components/catalog/screen-sizes'
import { isCypressInjected } from '../components/connection/provider'
import { WhitelistDeniedPopup } from '../components/waitlist/popups/DeniedPopup'
import { AlertBanner } from '../components/errors/AlertBanner'

declare const window: InjectedWindow

export const VIEW_STATE_POOLS = 0
export const VIEW_STATE_TRADE = 1
export const VIEW_STATE_DEPOSIT = 4
export const VIEW_STATE_FAUCET = 3
export const VIEW_STATE_WITHDRAW = 5

function chooseVisitPage(page: number): string {
  switch (page) {
    case VIEW_STATE_POOLS:
      visitPage.earn()
      return 'earn'
    case VIEW_STATE_TRADE:
      visitPage.trade()
      return 'trade'
    case VIEW_STATE_DEPOSIT:
      visitPage.deposit()
      return 'deposit'
    case VIEW_STATE_WITHDRAW:
      visitPage.withdraw()
      return 'withdraw'
  }
  return 'unknown_page'
}

interface AppProps {
  page: number
}
function App({ page }: AppProps) {
  const web3Context = useContext(Web3Context)
  let { loaded, accountState, accountStateDispatcher } = useAccountState()
  const { address, whitelisted, whitelistState, onWaitlist, waitlistState } =
    accountState

  if (isCypressInjected()) {
    loaded = false // disable account state for cypress
  }

  useEffect(() => {
    const pageName = chooseVisitPage(page)
    window.applicationContext.page = pageName
  }, [page])
  const appChainID = web3Context['appChainID']
  const account = web3Context.account
  const currentChain = supportedChains.find(c => c.config.appId == appChainID)

  const [theme, themeToggler, _] = useDarkMode()
  const { transactions, dispatcher } = useTransactions()
  const { poolId } = useParams()

  useEffect(() => {
    if (!transactions.loaded) {
      dispatcher({ type: 'load', data: { account, chainId: appChainID } })
    }
  }, [transactions.loaded])

  useEffect(() => {
    if (!account || !appChainID) {
      return
    }

    if (!transactions.loaded) {
      dispatcher({ type: 'load', data: { account, chainId: appChainID } })
    }
    dispatcher({ type: 'change', data: { account, chainId: appChainID } })
  }, [transactions.loaded, account, appChainID])

  return (
    <>
      <ThemeProvider theme={theme}>
        <div className={'popups'}>
          <Popups />
        </div>
        <GlobalStyles
          isSwap={page === VIEW_STATE_TRADE}
          isFaucet={page === VIEW_STATE_FAUCET}
        />
        <section className="all">
          <main className="App content">
            <section className="not-sticky">
              <Header>
                <AlertBanner />
                <NetworkBanner
                  appChainID={appChainID}
                  supportedChains={supportedChains}
                />
                <HeaderBody className={'header-body'}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div
                      style={{ display: 'flex', alignItems: 'center' }}
                      className={'headerRightContent'}
                    >
                      <Logo theme={theme} href={swaapAppURI} />
                      <div style={{ width: '1rem' }} />
                    </div>
                  </div>
                  <HideSmallerThan limit={desktopSize}>
                    <HeaderTabs page={page} />
                  </HideSmallerThan>
                  <div
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                    className={'headerLeftContent'}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <DarkModeSwitch
                          style={{
                            margin: '0, auto',
                            alignSelf: 'center',
                            marginRight: '0.3em',
                          }}
                          checked={theme === lightTheme}
                          onChange={() => {
                            themeToggler()
                            createVariousEvent().switched_theme(
                              theme === lightTheme ? 'light' : 'dark',
                              theme === lightTheme ? 'dark' : 'light'
                            )
                          }}
                          sunColor={swaapPurple0}
                          moonColor={swaapPurple1}
                          size={25}
                        />
                        {account && currentChain && (
                          <div style={{ marginRight: '0.5rem' }}>
                            <Bridge appChain={currentChain} />
                          </div>
                        )}
                        <Wallet />
                      </div>
                    </div>
                  </div>
                </HeaderBody>
              </Header>

              <Body>
                {page === VIEW_STATE_POOLS && <PoolsPage />}
                {page === VIEW_STATE_TRADE && <Swap />}
                {page === VIEW_STATE_DEPOSIT && (
                  <DepositPage poolId={poolId!} />
                )}
                {page === VIEW_STATE_WITHDRAW && (
                  <WithdrawPage poolId={poolId!} />
                )}

                {/* Whitelist popups management: TODO: move in a component */}
              </Body>
            </section>
          </main>

          <StickyFooter>
            <HideBiggerThan limit={desktopSize}>
              <HeaderTabs page={page} />
            </HideBiggerThan>
            <AppStatus />
          </StickyFooter>
        </section>
      </ThemeProvider>
    </>
  )
}

export default App
